﻿import { LiveDataSet, LiveDataSetStation, Status } from "../../API/LiveData/LiveDataSet";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { IStationValueFormatter, IStationValueObject, WarningThreshold } from "../../Formatters/IStationValueFormatter";
import { IHashData } from "../../IHashData";
import { ILiveDataListener } from "../../ILiveDataListener";
import { IPage } from "../../IPage";
import { MainSite } from "../../MainSite";
import { IRegion } from "../../Model/Region";
import { ParameterGroupInfo, ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { SiteObservations } from "../SiteObservations/SiteObservations";
import { StationPopup } from "./StationPopup";
// import Openlayer from 'openlayer';

declare var OpenLayers;

export class MapPage implements IPage, ILiveDataListener {
    
    constructor(private mainSite: MainSite) {
    }

    public id: string = 'map';

    private navBarLink: JQuery;
    private paramGroupInfos: ParameterGroupInfo[];

    private currentRegionId: string;

    private openPopups: string[];

    public initialize(): void {
        this.navBarLink = $('<li></li>').appendTo(this.mainSite.navBar.navLinksLeft);

        this.mainSite.liveDataManager.addListener(this);

        this.openPopups = [];

        $('<a></a>')
            .attr('href', '#')
            .click(() => {
                this.mainSite.changePage(this.id);
                return false;
            })
            .text('Map')
            .appendTo(this.navBarLink);
    }

    public handleHashChange(hashData: IHashData): boolean {

        if (hashData.Page === undefined || hashData.Page === '' || hashData.Page === this.id) {

            this.navBarLink.addClass('active');

            if (!this.map) {
                this.renderMap();
            }

            if (hashData.Region !== this.currentRegionId) {
                this.container.remove();
                this.renderMap();

                this.jumpToRegion(hashData.Region);
                this.currentRegionId = hashData.Region;
            }

            return true;
        } else {

            this.navBarLink.removeClass('active');

            if (this.map) {
                this.hide();
                this.currentRegionId = null;
            }

            this.openPopups = [];

            return false;
        }
    }

    private container: JQuery = null;

    private dropdownContainer: JQuery = null;
    //private dropdownContainerSelect: JQuery = null;
    private dropdownContainerSelectVal: JQuery = null;
    //private dropdownContainerSelectValContainer: JQuery = null;
    private dropdownContainerSelectValSpan: JQuery = null;

    private layerMenuContainer: JQuery = null;
    //private layerMenuContainerSelect: JQuery = null;
    private layerMenuContainerLayerItem: JQuery = null;
    //private layerMenuContainerLayerItemContainer: JQuery = null;
    private layerMenuContainerLayerItemSpan: JQuery = null;

    private removeExtraPlatformLabels: boolean = true;

    private static epgs4326 = new OpenLayers.Projection("EPSG:4326");

    private map: any;
    private platformsLayer: any;
    private hoverControl: any;
    private sensorNameParamGroupArray = [];
    private parameterGroup: ParameterGroupInfo = null;

    private renderMap() {
        this.container = $('<div id="midi_mapPage_map"></div>').appendTo('body');

        if ($.isEmptyObject(this.mainSite.staticDataManager.Schema.RegionSet.Regions)) {
            console.warn('MapPage.renderMap() - no Regions available!');
            this.container.html('<div class="alert alert-danger" style="margin: 80px;">Your Account on this site does not seem to have any Permissions set or access to any Regions.</div>');
            return;
        }

        //// Station Labels menu
        this.dropdownContainer = $('<div id="midi_mapPage_dropdown_container"></div>').appendTo(this.container);
        $('<div id="midi_mapPage_dropdown_text">Station Labels: </div>').appendTo(this.dropdownContainer);

        this.paramGroupInfos = [
            ParameterGroupInfoSet.WindDirection_deg,
            ParameterGroupInfoSet.WindSpeed_kts,
            ParameterGroupInfoSet.GustSpeed_kts,
            ParameterGroupInfoSet.AirTemperature_degC,
            ParameterGroupInfoSet.QNH_mbar,
            ParameterGroupInfoSet.First_CloudCover,
            ParameterGroupInfoSet.First_CloudBaseHeight_ft,
            ParameterGroupInfoSet.Visibility_m,
            ParameterGroupInfoSet.PresentWeather,
            ParameterGroupInfoSet.Hs_m,
            ParameterGroupInfoSet.T2_s,
            ParameterGroupInfoSet.Total_CurrentSpeed_Surface_mps_Mean,
            ParameterGroupInfoSet.Total_CurrentDirection_Surface_deg_Mean,
        ];

        this.buildLabelSelector();

        //// MAP
        this.map = new OpenLayers.Map({
            //maxExtent: new OpenLayers.Bounds(-20037508.34, -20037508.34, 20037508.34, 20037508.34),
            div: this.container[0],
            controls: [
                new OpenLayers.Control.Navigation(),
                new OpenLayers.Control.Zoom(),
                new OpenLayers.Control.ScaleLine({
                    className: 'olControlScaleLine'
                }),
                new OpenLayers.Control.Attribution({
                    className: 'olControlAttribution'
                })
            ],
            // optional
            maxResolution: 6957.46817458,
            maxExtent: new OpenLayers.Bounds(-10909310.0977, 2037548.54475, -9128198.24505,
                3503549.8435),
            //
            projection: new OpenLayers.Projection("EPSG:900913"),
            numZoomLevels: 22
        });


        var bm = new OpenLayers.Layer.XYZ("ESRI", 'https://tile.openstreetmap.org/${z}/${x}/${y}.png', {
            sphericalMercator: true,
            projection: "EPSG:900913",
            numZoomLevels: 10,
            attribution: '&copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> contributors', //: copied+adapted from class OpenLayers.Layer.OSM, found in Chrome console..
            wrapDateLine: true, //: https://web.archive.org/web/20200714181115/http://dev.openlayers.org/releases/OpenLayers-2.13.1/doc/apidocs/files/OpenLayers/Layer-js.html#OpenLayers.Layer.wrapDateLine
        });

        this.map.addLayer(bm);

        //// Drifter and front layers for selectedRegion.Id = GOM

        if (this.mainSite.selectedRegion.Id == "GOM") {

            this.addGOMLayers();

        }

        //// Styling

        var style = new OpenLayers.Style({
            cursor: 'pointer',
            strokeWidth: 1,
            pointRadius: 4,
            fillColor: "white",
            labelAlign: 'l',
            labelXOffset: 8,
            labelYOffset: -5,
            strokeColor: "#333333",
        });

        var ruleBig = new OpenLayers.Rule({
            symbolizer: {
                cursor: 'pointer',
                label: '${name}',
                labelSelect: true,
                fontColor: "#3b3b3b",
                fontSize: "12"
            },
            maxScaleDenominator: 8000000
        });

        var ruleSmall = new OpenLayers.Rule({
            symbolizer: {
                labelSelect: true
            },
            minScaleDenominator: 8000000
        });

        var ruleWarningDataRed = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#FF0000",
                strokeColor: "#333333"
            },
            filter:
                new OpenLayers.Filter.Comparison({
                    type: OpenLayers.Filter.Comparison.EQUAL_TO,
                    property: "warningLevel",
                    value: "Red"
                })

        });

        var ruleWarningDataAmber = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#FF8833",
                strokeColor: "#333333"
            },
            filter:
                new OpenLayers.Filter.Comparison({
                    type: OpenLayers.Filter.Comparison.EQUAL_TO,
                    property: "warningLevel",
                    value: "Amber"
                })

        });

        var ruleWarningDataYellow = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#FFD800",
                strokeColor: "#333333"
            },
            filter:
                new OpenLayers.Filter.Comparison({
                    type: OpenLayers.Filter.Comparison.EQUAL_TO,
                    property: "warningLevel",
                    value: "Yellow"
                })

        });

        var ruleAlignRight = new OpenLayers.Rule({
            symbolizer: {
                labelAlign: 'r',
                labelXOffset: -8
            },
            filter:
                new OpenLayers.Filter.Comparison({
                    type: OpenLayers.Filter.Comparison.EQUAL_TO,
                    property: "labelAlign",
                    value: "Right"
                })
        });

        let ruleShellAsset = new OpenLayers.Rule({
            symbolizer: {
                fillColor: "#fbce07",
            },
            filter: new OpenLayers.Filter.Comparison({
                type: OpenLayers.Filter.Comparison.EQUAL_TO,
                property: "shellAsset",
                value: "yes"
            })
        });

        style.addRules([ruleBig, ruleSmall, ruleShellAsset, ruleWarningDataRed, ruleWarningDataAmber, ruleWarningDataYellow, ruleAlignRight]);


        this.platformsLayer = new OpenLayers.Layer.Vector('Platforms', {
            styleMap: new OpenLayers.StyleMap(style)
        });

        this.map.addLayer(this.platformsLayer);

        this.createPlatformMarkers();


        this.map.events.register("mousemove", this.map, (e) => {
            this.lastMousePixel = e.xy;
        });

        this.createHoverControl();
        this.createClickControl();
    }



    private buildLabelSelector(): void {
        if (this.dropdownContainerSelectVal) {
            this.dropdownContainerSelectVal.remove();
            this.dropdownContainerSelectVal = null;
        }
        //this.dropdownContainerSelectValContainer = $('<div id="midi_mapPage_dropdown_select"></div>').appendTo(this.dropdownContainer);

        this.dropdownContainerSelectVal = $('<div class="dropdown" id="midi_mapPage_dropdown_select"></div>').appendTo(this.dropdownContainer);

        this.dropdownContainerSelectValSpan = $('<span>Station Name</span>');

        $('<a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false" href="#"><span class="caret"></span></a>')
            .prepend(this.dropdownContainerSelectValSpan)
            .appendTo(this.dropdownContainerSelectVal)
            .dropdown();

        var dd = $('<ul class="dropdown-menu midi_mapPage_dropdown_menu" role="menu"></ul>')
            .appendTo(this.dropdownContainerSelectVal);

        $('<a href="#"> Station Name </a>').click((e: JQueryMouseEventObject) => {
            this.dropdownContainerSelectValSpan.text('Station Name');
            this.dropdownContainerSelectVal.removeClass('open');
            this.removeExtraPlatformLabels = true;
            this.createPlatformMarkers();
            return false;
        }).appendTo($('<li></li>').appendTo(dd));

        this.paramGroupInfos.forEach((paramGroupInfo: ParameterGroupInfo) => {
            if (this.parameterGroup && this.parameterGroup.Id == paramGroupInfo.Id) {
                this.dropdownContainerSelectValSpan.text(paramGroupInfo.ShortName);
            }
            $('<li><a href="#">' + paramGroupInfo.ShortName + '</a></li>')
                .click((e: JQueryMouseEventObject) => {
                    this.dropdownContainerSelectValSpan.text(paramGroupInfo.ShortName);
                    this.parameterGroup = paramGroupInfo;
                    this.dropdownContainerSelectVal.removeClass('open');
                    this.removeExtraPlatformLabels = false;
                    this.createPlatformMarkers();

                    return false;
                }).appendTo(dd);

        });
    }

    private addGOMLayers(): void {

        this.layerMenuContainer = $('<div id="midi_mapPage_layerMenu_container"></div>').appendTo(this.container);

        // define layers of interest
        // see demos here: https://services.woodsholegroup.com/shell/demo/
        const layers = {
            // "Drifters" are freely-floating drifting buoys that are deployed in the ocean to measure currents.
            "Drifter Layers": [
                {
                    "id": "drifter_tracks_24h-today_minus01",
                    "label": "-1 day"
                },
                {
                    "id": "drifter_tracks_96h-today_minus04",
                    "label": "-4 days"
                }
            ],
            // "Fronts" are...
            "Front Layers": [
                {
                    "id": "fronts_gomex-today_minus00",
                    "label": "Today"
                },
                {
                    "id": "fronts_gomex-today_minus01",
                    "label": "-1 day"
                },
                {
                    "id": "fronts_gomex-today_minus02",
                    "label": "-2 days"
                },
                {
                    "id": "fronts_gomex-1wk_progression",
                    "label": "1 week progression"
                }
            ]
        };

        // for all layerTypes
        for (const [layerType, _layers] of Object.entries(layers)) {

            $(`<div class="midi_mapPage_layerMenu_layerTypeLabel" id="${layerType}">${layerType}: </div>`).appendTo(this.layerMenuContainer);

            _layers.forEach((layerSpecs, index) => {

                //// add layer to map
                const layer = new OpenLayers.Layer.WMS(
                    `WMS ${layerSpecs.id}`,
                    "/api/WoodsHoleWmsProxy?",
                    {
                        layers: layerSpecs.id,
                        format: "image/png",
                        srs: "EPSG:900913",
                        exceptions: "application/vnd.ogc.se_inimage",
                        transparent: true,
                        token: "Basic " + window.btoa('shell:SleepingBear$56')
                    },
                    {
                        singleTile: true,
                        ratio: 1,
                        isBaseLayer: false,
                    });

                //const isVisible = layerName == "fronts_gomex-today_minus00" || layerName == "drifter_tracks_24h-today_minus01";
                const isVisible = layerSpecs.id == "drifter_tracks_24h-today_minus01";

                layer.setVisibility(isVisible);

                this.map.addLayer(layer);

                //// add layer to menu
                this.layerMenuContainerLayerItem = $('<div class="midi_mapPage_layerMenu_layerItem"></div>').appendTo(this.layerMenuContainer);

                // Checkbox and label
                const layerCheckbox = $(`<input type="checkbox" ${isVisible ? "checked" : ""} id="${layerSpecs.id}" class="midi_mapPage_layerMenu_checkbox">`);
                const layerLabel = $(`<label for="${layerSpecs.id}" class="midi_mapPage_layerMenu_layerLabel" >${layerSpecs.label}</label>`);

                this.layerMenuContainerLayerItem.append(layerCheckbox);
                this.layerMenuContainerLayerItem.append(layerLabel);

                // on change, do...
                layerCheckbox.change(function () {
                    layer.setVisibility(this.checked);
                });


            });
        }
    }

    private hide(): void {
        if (this.popup) {
            this.popup.remove();
            this.popup = null;
        }

        this.map.destroy();
        this.container.remove();

        this.container = null;
        this.map = null;
    }

    private lastMousePixel: MapHoverPixel = null;

    private mouseOverFeature: boolean = false;

    private createHoverControl(): void {

        this.container.mouseenter(() => {
            if (this.popup) {
                if (!this.popup.mouseIn && !this.mouseOverFeature) {
                    this.popup.remove();
                    this.popup = null;
                }
            }
        });

        this.hoverControl = new OpenLayers.Control.SelectFeature(this.platformsLayer, {
            hover: true,
            highlightOnly: true,
            eventListeners: {
                featurehighlighted: (e: any) => {
                    this.mouseOverFeature = true;
                    if (this.popup) {
                        this.popup.remove();
                        this.popup = null;
                    }
                    this.showPopUp(this.lastMousePixel, e.feature.id);
                },
                featureunhighlighted: () => {
                    this.mouseOverFeature = false;
                    setTimeout(() => { this.maybeRemovePopUp(); }, 2000);
                }
            }
        });
        this.map.addControl(this.hoverControl);
        this.hoverControl.activate();
    }

    private maybeRemovePopUp(): void {
        if (this.popup) {
            if (!this.popup.mouseIn && !this.mouseOverFeature) {
                this.popup.remove();
                this.popup = null;
            }
        }
    }

    private createClickControl(): void {
        var clickControl = new OpenLayers.Control.SelectFeature(this.platformsLayer, {
            onBeforeSelect: (feature: any) => {
                var hashData: IHashData = this.mainSite.hashDataManager.decode(window.location.hash);
                hashData.Page = "siteObs";
                hashData.PageSpecificData = {
                    Tab: SiteObservations.getLandingPageId(feature.attributes.id),
                    Station: feature.attributes.id
                };
                window.location.hash = this.mainSite.hashDataManager.encode(hashData);

            }
        });

        this.map.addControl(clickControl);
        clickControl.activate();
    }

    public liveDataChanged(latestData: LiveDataSet): void {
        if (this.map) {
            this.createPlatformMarkers();
        }
        if (this.popup) {
            this.popup.refreshData(latestData);
        }
    }

    private createPlatformMarkers() {
        if (!this.mainSite.liveDataManager.latestData) {
            return;
        }

        var mapProjection = this.map.getProjectionObject();

        var labelAlignLeft = true;
        for (var stationId in this.mainSite.liveDataManager.latestData.Stations) {
            var station: LiveDataSetStation = this.mainSite.liveDataManager.latestData.Stations[stationId];

            // set station label here depending on what is on drop down

            var stationLabel = station.Station.ShortLabel ?? station.Station.Label;
            if (this.parameterGroup && !this.removeExtraPlatformLabels) {
                var valueFormatter: IStationValueFormatter = new DefaultGroupFormatter(this.parameterGroup);
                var valueObject: IStationValueObject = valueFormatter.format(station);

                stationLabel += (stationLabel.trim() !== "" ? "\n" : "") + valueObject.Value;

                if (this.parameterGroup.Units && (valueObject.Status == Status.Good || valueObject.Status == Status.Expiring)) {
                    stationLabel += " " + this.parameterGroup.Units;
                }
            }

            //: If LiveData contains single, valid latest Buoy Lat/Lon, then update position on map:
            let markerLon = station.Station.Longitude;
            let markerLat = station.Station.Latitude;
            try {
                const lonValue = station.GroupValues[ParameterGroupInfoSet.Buoy_Longitude_deg.Id];
                const latValue = station.GroupValues[ParameterGroupInfoSet.Buoy_Latitude_deg.Id];

                //console.info('MapPage.createPlatformMarkers().. buoy autoupdate?', { station: station.Station.Id, markerLon: markerLon, markerLat: markerLat, buoyPosValueFormatterLon: buoyPosValueFormatterLon, buoyPosValueObjectLon: buoyPosValueObjectLon, buoyPosValueFormatterLat: buoyPosValueFormatterLat, buoyPosValueObjectLat: buoyPosValueObjectLat });

                if (lonValue && lonValue.length && !isNaN(parseFloat(lonValue[0].Value))
                    && latValue && latValue.length && !isNaN(parseFloat(latValue[0].Value))
                ) {
                    markerLon = parseFloat(lonValue[0].Value);
                    markerLat = parseFloat(latValue[0].Value);
                    // let move = !(markerLon == station.Station.Longitude && markerLat == station.Station.Latitude);
                    // console.info('MapPage.createPlatformMarkers().. buoy autoupdate?', { station: station.Station, move: move, markerLon: markerLon, markerLat: markerLat, buoyLon: [buoyPosValueObjectLon.Value, buoyPosValueObjectLon.Status], buoyPosValueObjectLat: [buoyPosValueObjectLat.Value, buoyPosValueObjectLat.Status] });
                }
            } catch (err) {
                console.warn('Error while trying to auto-update marker position:', { error: err, station: station });
            }

            var feature = this.platformsLayer.getFeatureById(station.Station.Id);

            if (feature) {
                this.platformsLayer.removeFeatures([
                    feature
                ]);
            }

            // Feature does not yet exist, create it
            var attributes = {
                name: stationLabel,
                id: station.Station.Id,
                warningLevel: this.determineFeatureWarningLevel(station.Station.Id),
                shellAsset: station.Station.ShellAsset ? 'yes' : 'no' //: using strings as not sure OpenLayers.Rule can handle booleans!
            };

            var point = new OpenLayers.Geometry.Point(markerLon, markerLat).transform(MapPage.epgs4326, mapProjection);
            var newFeature = new OpenLayers.Feature.Vector(point, attributes);
            newFeature.id = station.Station.Id;

            if (labelAlignLeft) {
                newFeature.attributes.labelAlign = 'Left';
                labelAlignLeft = false;
            }
            else {
                newFeature.attributes.labelAlign = 'Right';
                labelAlignLeft = true;
            }

            this.platformsLayer.addFeatures([
                newFeature
            ]);
        }

        // Remove features that are no longer in the live data
        this.platformsLayer.features.forEach((oldFeature) => {
            if (!(oldFeature.id in this.mainSite.liveDataManager.latestData.Stations)) {
                this.platformsLayer.removeFeatures([
                    oldFeature
                ]);
            }
        });
    }

    private determineFeatureWarningLevel(featureId: string): any {
        var warningLevelRed = false;
        var warningLevelAmber = false;
        var warningLevelYellow = false;


        this.paramGroupInfos.forEach((paramGroupInfo: ParameterGroupInfo) => {

            var valueFormatter = new DefaultGroupFormatter(paramGroupInfo);

            var valueObject: IStationValueObject = valueFormatter.format(this.mainSite.liveDataManager.latestData.Stations[featureId]);

            if (valueObject.Status === null || valueObject.Status == Status.Expired) {
                return;
            }

            if (valueObject.WarningThreshold == WarningThreshold.Level3) {
                warningLevelRed = true;
            } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
                warningLevelAmber = true;
            } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
                warningLevelYellow = true;
            }
        });

        var warningLevel;

        if (warningLevelRed) {
            warningLevel = 'Red';
        }
        else if (warningLevelAmber) {
            warningLevel = 'Amber';
        }
        else if (warningLevelYellow) {
            warningLevel = 'Yellow';
        }
        else {
            warningLevel = 'None';
        }
        return warningLevel;
    }

    private jumpToRegion(regionId: string) {
        var region: IRegion = this.mainSite.staticDataManager.Schema.RegionSet.Regions[regionId];
        if (region) {
            var position = new OpenLayers.LonLat(region.Longitude, region.Latitude).transform(MapPage.epgs4326, this.map.getProjectionObject());
            this.map.setCenter(position, region.ZoomLevel);
        } else {
            console.warn('MapPage.jumpToRegion() ERROR: unable to jump to region.', { region: region });
        }
    }


    private popup: StationPopup;

    private showPopUp(pixel: MapHoverPixel, stationId: string): void {
        this.popup = new StationPopup(this.mainSite, stationId, [pixel.x, pixel.y], this.mainSite.liveDataManager.latestData, this.openPopups);

    }
}

interface MapHoverPixel {
    x: number;
    y: number;
}